export const content = {
  errors: {
    required: 'Eingabe erforderlich',
  },
}
